import { render } from "./SupervisorClaimsComponent.vue?vue&type=template&id=66e4e987&scoped=true"
import script from "./SupervisorClaimsComponent.vue?vue&type=script&lang=js"
export * from "./SupervisorClaimsComponent.vue?vue&type=script&lang=js"

import "./SupervisorClaimsComponent.vue?vue&type=style&index=0&id=66e4e987&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e4e987"]])

export default __exports__